import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { OktaConfigProvider } from '@app/okta-config-provider';
import { EnvironmentService } from 'pf-shared-lib-ui/coreLib';

async function appInit() {
    const appModuleContainer = await import('./app/app.module');
    platformBrowserDynamic()
        .bootstrapModule((appModuleContainer).AppModule)
        .then((ref) => {
            // Ensure Angular destroys itself on hot reloads.
            // tslint:disable: no-string-literal
            if ((window as any)['ngRef']) {
                (window as any)['ngRef'].destroy();
            }
            (window as any)['ngRef'] = ref;
        })
        .catch((err) => console.error(err));
}
fetch('config/config.json').then(res => res.json()).then(async (response) => {
    EnvironmentService.setConfig(response);
    OktaConfigProvider.setConfig(response.issuer, response.clientId);
    (window as any)['config'] = response;
    if (response.production) {
        enableProdMode();
        if (window && window.location.host !== 'localhost:4200') {
            window.console.log = window.console.warn = window.console.info = () => {
                // Don't log anything.
            };
        }
    }
}).finally(appInit);